/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-06 19:30:33
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-12-08 12:41:50
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelEditorAppearance/tools.ts
 */
import { linkImgValidation } from '@/src/constrains/DraggableModules/tools';
import { convertSpecificError } from '@/src/constrains/SalesChannelPreviewPageComponents/tools';
import { errCodesMap } from '@/src/error/code';
import {
  generateDefaultFlashSaleBarStyle,
  generateDefaultFloatingActionButtonStyle,
  generateDefaultFont,
  generateDefaultNavigationBar,
  generateDefaultPrimaryCallToActionButtonStyle,
  generateDefaultProductDetailsPageTabBarStyle,
  generateDefaultSecondaryCallToActionButtonStyle,
  generateDefaultTopLeaderBoardBanner,
} from 'src/pages/SalesChannelContentEditor/SalesChannelEditorAppearance/common';
//import { changedStatus } from 'src/tools/constant';
import { reduxUpdatedStatusControl } from 'src/tools/helper';

const convertDataFromServerToRedux = (data) => {
  const {
    contentUuid,
    salesChannelContent,
    salesChannelName,
    uuid,
    productDetailsPageTabBarStyle,
    primaryCallToActionButtonStyle,
    secondaryCallToActionButtonStyle,
    flashSaleBarStyle,
    font,
    enableRemainingStockTextStyle,
    remainingStockTextStyle,
    miniProgramNavBar,
    topLeaderBoardBanner,
    loadingImage,
    floatingActionButtonStyle,
  } = data;
  const { buttonStyle } = primaryCallToActionButtonStyle;
  const { outlineStyle } = secondaryCallToActionButtonStyle;
  return {
    contentUuid,
    salesChannelContent,
    salesChannelName,
    enableRemainingStockTextStyle,
    remainingStockTextStyle,
    uuid,
    loadingAnimation: loadingImage,
    topLeaderBoardBanner:
      topLeaderBoardBanner || generateDefaultTopLeaderBoardBanner(),
    productDetailsPageTabBarStyle:
      productDetailsPageTabBarStyle ||
      generateDefaultProductDetailsPageTabBarStyle(),
    flashSaleBarStyle: flashSaleBarStyle || generateDefaultFlashSaleBarStyle(),
    primaryCallToActionButtonStyle:
      buttonStyle || generateDefaultPrimaryCallToActionButtonStyle(),
    secondaryCallToActionButtonStyle:
      outlineStyle || generateDefaultSecondaryCallToActionButtonStyle(),
    font: font || generateDefaultFont(),
    miniProgramNavBar: miniProgramNavBar || generateDefaultNavigationBar(),
    floatingActionButtonStyle:
      floatingActionButtonStyle || generateDefaultFloatingActionButtonStyle(),
    ...reduxUpdatedStatusControl,
  };
};

const convertDataFromReduxToServer = (state) => {
  const {
    contentUuid,
    uuid,
    flashSaleBarStyle,
    productDetailsPageTabBarStyle,
    primaryCallToActionButtonStyle,
    secondaryCallToActionButtonStyle,
    remainingStockTextStyle,
    font,
    loadingAnimation,
    topLeaderBoardBanner,
    miniProgramNavBar,
    floatingActionButtonStyle,
  } = state;

  const primaryCallToActionButtonStyleData = {
    buttonStyle: primaryCallToActionButtonStyle,
  };

  const secondaryCallToActionButtonStyleData = {
    outlineStyle: secondaryCallToActionButtonStyle,
  };

  return {
    contentUuid,
    uuid,
    flashSaleBarStyle,
    productDetailsPageTabBarStyle,
    primaryCallToActionButtonStyle: primaryCallToActionButtonStyleData,
    secondaryCallToActionButtonStyle: secondaryCallToActionButtonStyleData,
    remainingStockTextStyle,
    font,
    topLeaderBoardBanner,
    loadingImage: loadingAnimation,
    miniProgramNavBar,
    floatingActionButtonStyle,
  };
};

export { convertDataFromServerToRedux, convertDataFromReduxToServer };

export const topLeaderBoardBannerValidation = (data) => {
  const generalError = [];
  let specificErr = {};
  const { link } = data || {};

  specificErr = linkImgValidation({
    data: link,
    err: specificErr,
    suffixKey: '',
  });
  return {
    hasError: convertSpecificError(specificErr).length > 0,
    specificError: specificErr,
    generalError,
  };
};

export const validateImageStateSetting = (data) => {
  const specificErr = {};
  const generalError = [];
  if (!(data || {}).uuid) {
    generalError.push(errCodesMap[199221]);
  }
  return {
    hasError: convertSpecificError(specificErr).length > 0,
    specificError: specificErr,
    generalError,
  };
};
